<ng-container *ngIf="show === 'text'">
    <span class="text-break-all">{{trackingData}}</span>
</ng-container>
<ng-container *ngIf="show === 'link'">
    <a class="link link-underline small d-block text-break-all" [href]="trackingNumbers[0].url" title="Click here to view more" target="_blank">{{trackingNumbers[0].number}}</a>
    <span class="d-block text-break-all">{{ trackingNumbers[0].carrier_name === "N/A" ? "N/A" : trackingNumbers[0].carrier_name | translate }}</span>
</ng-container>
<ng-container *ngIf="show === 'modal'">
    <button class="tracking--view-all" (click)="showDetails(content)">View All</button>
    <ng-template #content let-modal>
        <div class="modal-header">
        <h1 class="modal-title text-truncate full-width text-align-center" id="modal-label">Tracking Details</h1>
            <button type="button" class="close btn btn-icon" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true" class="fal fa-times"></span>
            </button>
        </div>
        <div class="modal-body">
            <div class="container tracking--list ">
                <ng-container *ngFor="let track of trackingNumbers">
                    <div class="row tracking--row">
                        <div class="tracking--cell">
                          <label class="label font-5">SKU</label>
                          <div class="tracking--state" [innerHTML]="track.sku_number"></div>
                        </div>
                        <div class="tracking--cell">
                          <label class="label font-5">Status</label>
                          <div class="tracking--state" [ngClass]="{delivered: isDelivered(track.status)}" [innerHTML]="track.status | translate"></div>
                        </div>
                        <div  class="tracking--cell">
                          <label class="label font-5">Tracking</label>
                          <div class="tracking--link text-break-all">
                            <ng-container *ngIf="track.mode === 'link'">
                              <a class="link link-underline small d-block" *ngIf="track.mode === 'link'" [href]="track.url" title="Click to view more" target="_blank">{{track.number}}</a>
                              <span class="d-block"> {{track.carrier_name === "N/A" ? "N/A" : track.carrier_name | translate}}</span>
                            </ng-container>
                          </div>
                        </div>
                        <div  class="tracking--cell shipped-qty">
                          <label class="label font-5">Shipped Quantity</label>
                          <div class="tracking--state"  [innerHTML]="track.quantity"></div>
                        </div>
                      <div  class="tracking--cell">
                        <label class="label font-5">Shipped Date</label>
                        <div class="tracking--state "  [innerHTML]="track.shipping_date | dateFormat"></div>
                      </div>

                    </div>
                </ng-container>
            </div>
        </div>
    </ng-template>
</ng-container>
